import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';

const DealStatusIndicator = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');
  const [activeDeal, setActiveDeal] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setCurrentLanguage(savedLanguage);

    const dealData = localStorage.getItem('activeDeal');
    if (dealData) {
      setActiveDeal(JSON.parse(dealData));
    }
  }, []);

  const translations = {
    en: {
      pending: 'Pending',
      inProgress: 'In Progress',
      completed: 'Completed',
      disputed: 'Disputed',
      viewDetails: 'View Details',
      dealStatus: 'Deal Status'
    },
    ko: {
      pending: '대기 중',
      inProgress: '진행 중',
      completed: '완료됨',
      disputed: '분쟁 중',
      viewDetails: '세부정보 보기',
      dealStatus: '거래 상태'
    }
  };

  const t = translations?.[currentLanguage];

  const statusConfig = {
    pending: {
      color: 'var(--color-warning)',
      bgColor: 'bg-warning/10',
      icon: 'Clock',
      label: t?.pending
    },
    inProgress: {
      color: 'var(--color-primary)',
      bgColor: 'bg-primary/10',
      icon: 'Loader',
      label: t?.inProgress
    },
    completed: {
      color: 'var(--color-success)',
      bgColor: 'bg-success/10',
      icon: 'CheckCircle',
      label: t?.completed
    },
    disputed: {
      color: 'var(--color-error)',
      bgColor: 'bg-error/10',
      icon: 'AlertTriangle',
      label: t?.disputed
    }
  };

  if (!activeDeal) {
    return null;
  }

  const status = statusConfig?.[activeDeal?.status] || statusConfig?.pending;

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="fixed top-20 right-6 z-150 hidden lg:block">
      <div className={`bg-card border border-border rounded-lg shadow-elevation-lg transition-base ${isExpanded ? 'w-80' : 'w-64'}`}>
        <button
          onClick={toggleExpanded}
          className="w-full flex items-center justify-between p-4 hover:bg-muted/50 transition-base rounded-t-lg"
        >
          <div className="flex items-center gap-3">
            <div className={`w-10 h-10 ${status?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={status?.icon} size={20} color={status?.color} />
            </div>
            <div className="text-left">
              <p className="text-sm font-medium text-foreground caption">{t?.dealStatus}</p>
              <p className="text-xs text-muted-foreground caption">{status?.label}</p>
            </div>
          </div>
          <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={20} />
        </button>

        {isExpanded && (
          <div className="p-4 border-t border-border">
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground caption">Deal ID</span>
                <span className="text-sm font-medium data-text">{activeDeal?.id}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground caption">Amount</span>
                <span className="text-sm font-medium data-text">${activeDeal?.amount}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-sm text-muted-foreground caption">Updated</span>
                <span className="text-sm font-medium data-text">{activeDeal?.lastUpdated}</span>
              </div>
              <button className="w-full mt-2 flex items-center justify-center gap-2 px-4 h-10 rounded-lg bg-primary text-primary-foreground hover:opacity-90 transition-base">
                <Icon name="ExternalLink" size={16} />
                <span className="text-sm font-medium">{t?.viewDetails}</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DealStatusIndicator;